<template>
  <div class="c-dropdown" @click:outside="open = false" ref="dropdown">
    <button :disabled="disabled" type="button" @click.stop="toggleMenu()" class="c-dropdown-btn">
      <slot name="button"></slot>
    </button>
    <div :class="{ open: open, 'position-top': shouldOpenTop }" class="c-dropdown-content" :style="setStyle">
      <slot name="dropdown-item"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLeft: { type: Boolean, default: false },
    contentStyle: { type: String, default: '' },
    listStyle: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      open: false,
      shouldOpenTop: false
    }
  },
  computed: {
    setStyle() {
      let textStyle = ''
      if (this.isLeft) textStyle += 'right: 0; '
      else if (this.listStyle) textStyle += this.listStyle

      if (this.contentStyle) textStyle += this.contentStyle
      return textStyle
    }
  },
  methods: {
    toggleMenu() {
      if (this.disabled) {
        this.open = false;
      } else {
        this.open = !this.open
        if (this.open) {
          this.$nextTick(() => {
            this.calculatePosition()
          })
        }
      }
    },
    calculatePosition() {
      const dropdown = this.$refs.dropdown
      if (!dropdown) return

      const rect = dropdown.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      const spaceBelow = viewportHeight - rect.bottom
      const menuHeight = 150 // estimated menu height

      // If there's not enough space below (less than menu height), open upward
      this.shouldOpenTop = spaceBelow < menuHeight
    }
  },
  mounted() {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.open = false
      }
    })
  },
}
</script>

<style scoped>
.c-dropdown-btn {
  background-color: transparent;
  border: none;
}

.c-dropdown {
  position: relative;
  display: inline-block;
}

.c-dropdown-content {
  margin-top: 3px;
  color: #4F4F4F;
  border-radius: 5px;
  overflow: hidden;
  border-right: 1px solid #BDBDBD;
  border-left: 1px solid #BDBDBD;
  border-bottom: 1px solid #BDBDBD;
  border-top: 1px solid #BDBDBD;
  position: absolute;
  background-color: white;
  display: none;
  min-width: 100px;
  width: max-content;
  z-index: 2;
}

.c-dropdown-content.position-top {
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 3px;
}

.c-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.c-dropdown a:hover {
  background-color: #ddd;
}

.open {
  display: block;
}
</style>

<style scoped>
button:focus {
  border: none;
  outline: none;
}
</style>